// Module
var code = "<h1 id=upload-上传>Upload 上传</h1> <p>通用上传。</p> <p>用于上传office、图片、pdf等文件。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...。</li> </ul> ";
// Exports
module.exports = code;